export const ADD_TEXT_EDITOR = 'add_text_editor'
export const SET_ACTIVE_EDITOR = 'set_active_editor'
export const UPDATE_TEXT_EDITOR = 'update_text_editor'


// WEBPACK FOOTER //
// ./src/store/types/textEditors.js